import clsx from 'clsx';
import React, { useLayoutEffect, useRef } from 'react';
import styles from './Badge.module.scss';
export const BADGE_COLORS = [
    'red',
    'orange',
    'white',
    'green',
    'darkBlue'
];
export const BADGE_LOCATIONS = [
    'topLeft',
    'topRight'
];
export const Badge = ({ color, location, badge, children })=>{
    const wrapperRef = useRef(null);
    useLayoutEffect(()=>{
        const wrapper = wrapperRef.current;
        if (wrapper == null) return;
        const child = wrapper.firstElementChild;
        if (child == null) return;
        wrapper.style.borderRadius = getComputedStyle(child).borderRadius;
        const updateWrapperWidth = ()=>{
            wrapper.style.width = '100%';
            const childWidth = child.getBoundingClientRect().width;
            wrapper.style.width = `${childWidth}px`;
        };
        const parentResizeObserver = new ResizeObserver(()=>updateWrapperWidth());
        if (wrapper.parentElement != null) parentResizeObserver.observe(wrapper.parentElement);
        return ()=>parentResizeObserver.disconnect();
    }, [
        children
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        ref: wrapperRef,
        className: styles.wrapper
    }, children, /*#__PURE__*/ React.createElement("div", {
        className: styles.badgeContainer
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.badge, styles[color], styles[location])
    }, badge)));
};
